import { testConfig } from '@/config'

// 展示下载资源列表的类型
// export const showDownloadTypeList = ['hskk1', 'hskk2', 'hskk3']
// hskk需求修改202503
export const showDownloadTypeList = []
// 隐藏跳转资源按钮的类型
export const hideResourceList = ['hsk7', 'hskk1', 'hskk2', 'hskk3']
// 隐藏-考试形式-例题按钮
export const hidetestTabelExpleList = ['hsk7', 'hskk1', 'hskk2', 'hskk3', 'new-hsk1', 'new-hsk2', 'new-hsk3', 'new-hsk4', 'new-hsk5', 'new-hsk6']
// 显示testForm表单，展示第三列的合并单元
  //export const showtestTableDescList = ['hsk7']
// hskk需求修改202503
export const showtestTableDescList = ['hsk7', 'hskk1', 'hskk2', 'hskk3']
// 隐藏词汇tab
export const hideVocabulary = ['hskk1', 'hskk2', 'hskk3']
// hskk需求修改202503
// export const hideVocabulary = []
// 隐藏介绍中的跳转
export const hideDescribeLink = ['hskk1', 'hskk2', 'hskk3']
// hskk需求修改202503
// export const hideDescribeLink = []
// 根据数字等级获取真正的等级
export const getRealLevelName = (type, level) => {
  let lowerCaseType = type.toLowerCase()
  let levelTypeName = lowerCaseType + level
  switch (levelTypeName) {
    case 'hsk7':
      return '7-9'
    case 'hskk1':
      return 'B'
    case 'hskk2':
      return 'I'
    case 'hskk3':
      return 'A'
    default:
      return level
  }
}
// hsk7-9翻译考试中，语言列表维护；
export const translationLanguageList = [
  {
    title: 'English',
    value: 'en',
  },
   {
    title: 'English',
    value: 'en-us',
  },
  {
    title: '日本語',
    value: 'ja',
  },
  {
    title: 'بالعربية',
    value: 'ar',
  },
  {
    title: 'Русский язык',
    value: 'ru',
  },
   {
    title: '한국어',
    value: 'ko',
  },
  {
    title: 'Български',
    value: 'bg',
  },
    {
    title: 'Монгол',
    value: 'mn',
  },
  {
    title: "ภาษาไทย",
    value: "th",

  },
    {
    title: "Español",
    value: "es",
  },
   {
    title: 'Tiếng Việt',
    value: 'vn',
  },
  {
    title: 'Tiếng Việt',
    value: 'vi',
  },
  {
    title: 'Français',
    value: 'fr',
  },
]
export const freePracticeComponentsList = [
  {
    componentName: 'TypesOfPractice',
    title: 'choose_free_practice',
    step: 1,
    typeOfPracticeArr: ['FLASHCARDS','EXERCISE','ANALYSE'],
    commonHeader: true,
    backgroundColor: '#fff'
  },
  {
    componentName: 'TestCreation',
    title: 'flashcards_title',
    step: 2,
    typeOfPracticeArr: ['FLASHCARDS'],
    commonHeader: false,
    backgroundColor:'#fff'
  },
  {
    componentName: 'TestCreation',
    title: 'practice_exercises_title',
    step: 2,
    typeOfPracticeArr: ['EXERCISE'],
    commonHeader: false,
    backgroundColor: '#fff'
  },
  {
    componentName: 'Analyse',
    title: 'analyse_title',
    step: 2,
    typeOfPracticeArr: ['ANALYSE'],
    commonHeader: true,
    backgroundColor: '#fff'
  },
  {
    componentName: 'Flashcards',
    title: 'flashcards_title',
    step: 3,
    typeOfPracticeArr:['FLASHCARDS'] ,
    commonHeader: true,
    backgroundColor: '#fafafb'
  },
  {
    componentName: 'PracticeExercises',
    title: 'practice_exercises_title',
    step: 3,
    typeOfPracticeArr: ['EXERCISE'],
     commonHeader: true,
    backgroundColor: '#fff'
  },
  {
    componentName: 'PracticeResult',
    title: 'Practice Result',
    step: 4,
    typeOfPracticeArr: ['FLASHCARDS','EXERCISE'],
    commonHeader: false,
    backgroundColor: '#fff'
  },
]
export function getTestType(string) {
  let path = string.toUpperCase()
  for (let prop in testConfig) {
    if (prop == path) {
      return Number(testConfig[prop])
    }
  }
  return null
}

/**
 * @param {*} arr 扁平levelList
 * @param {*} keyObj 获取唯一对象参数
 */
export function getLevelItem(arr, propsObj) {
  // levelId,level,type，type_name
  Object.keys(propsObj).forEach((key) => {
    if (!propsObj[key]) {
      delete propsObj[key]
    }
  })
  let keyObj = {}
  const oneDependenceType = ['id', 'level_name'] // 优先级高
  const twoDependenceType = [
    ['level_id', 'type'],
    ['level_id', 'type_name'],
  ]
  // 检查参数是否可以获取对象
  let dependecetype = null // null 1 2
  Object.keys(propsObj).forEach((key) => {
    // 有唯一值的，只保留唯一值
    if (oneDependenceType.indexOf(key) > -1) {
      keyObj[key] = propsObj[key]
      dependecetype = 1
    }
  })
  if (!dependecetype) {
    twoDependenceType.forEach((typeArr) => {
      // 有通过两个参数获取levelId的情况，只保留两个值
      if (propsObj[typeArr[0]] && propsObj[typeArr[1]]) {
        keyObj[typeArr[0]] = propsObj[typeArr[0]]
        keyObj[typeArr[1]] = propsObj[typeArr[1]]
        dependecetype = 2
      }
    })
  }

  let result = null

  if (dependecetype) {
    arr.forEach((level) => {
      let flag = true
      Object.keys(keyObj).forEach((key) => {
        if (level[key] != keyObj[key]) {
          flag = false
        }
      })
      if (flag) {
        result = level
        return level
      }
    })
  }
  return result
}


export const getSegmentDuration = (segmentItem, levelId) => {
  // 模块的倒计时时间
  let duration = segmentItem.duration  * 60 * 1000
  let segmentCode = segmentItem.segmentCode
  // 以下设置没有倒计时的模块
  // levelId == 12 hsk7-9试卷,写作没有倒计时
  if (segmentCode == 'write' && (levelId == 12 || levelId == 8 || levelId == 13 || levelId == 14)) {
    duration = -1
  }
  // 听力|翻译|口语没有没有倒计时
  if (segmentCode == 'listen' || segmentCode == 'translation' || segmentCode == 'speaking') {
    duration = -1
  }
  return duration
}

export const getSegmentPartsDuration = (segmentItem, prevCount) => {
  let start = prevCount
 let list =  segmentItem.parts.map(part => {

    let tempObj =  {
        partCode: part.partCode,
        part_answer_time: part.part_answer_time == 0 ? -1 : part.part_answer_time * 60 * 1000,
            //  part_answer_time:  part.part_answer_time == 0 ? -1 : 60 * 1000,
        startQuestion: start + 1,
        endQuestion: start + part.questionCount,
        currentPart: false
    }
      start =  start + part.questionCount
      return tempObj

 })
  return list
}


export const getLanguageSelectList = (screen_text_trans) => {
  return  screen_text_trans.map(item => {
   return translationLanguageList.find(lan => {
     return  lan.value == item.lang
    })
  })


}

export const getScreenTextByLanguage = (contentList, lang) => {
  let obj = contentList.find(item => item.lang == lang )
  return obj?.content?obj.content: ''
}
